import {
  ClipboardPenLine,
  Images,
  MessageSquareText,
  Sparkles,
} from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import NewOrderPage from "../orders/NewOrderPage";
import CreatePage from "./CreatePage";
import "./CreateHubPage.css";

const createModes = [
  {
    value: "post",
    title: "发布设计作品",
    description: "分享海报、宣传图与品牌视觉作品，沉淀你的设计主页。",
    action: "创建帖子",
    icon: Images,
    accentIcon: Sparkles,
  },
  {
    value: "order",
    title: "发布设计需求",
    description: "说明预算、交付物与验收标准，寻找合适的设计服务者。",
    action: "发布需求",
    icon: ClipboardPenLine,
    accentIcon: MessageSquareText,
  },
];

function CreateModeSwitcher({ activeMode, onChange }) {
  return (
    <nav className="create-mode-switcher" aria-label="创建类型">
      {createModes.map((mode) => {
        const Icon = mode.icon;
        return (
          <button
            key={mode.value}
            className={activeMode === mode.value ? "active" : ""}
            type="button"
            aria-pressed={activeMode === mode.value}
            onClick={() => onChange(mode.value)}
          >
            <Icon size={17} />
            {mode.action}
          </button>
        );
      })}
    </nav>
  );
}

function CreateTypePicker({ onChoose }) {
  return (
    <section className="page-container narrow-page create-type-page">
      <div className="create-type-heading">
        <span className="eyebrow">统一创建中心</span>
        <h1>这次想发布什么？</h1>
        <p>选择一种创建类型，作品分享与设计需求都可以从这里开始。</p>
      </div>
      <div className="create-type-grid">
        {createModes.map((mode) => {
          const Icon = mode.icon;
          const AccentIcon = mode.accentIcon;
          return (
            <button
              className={`create-type-card ${mode.value}`}
              key={mode.value}
              type="button"
              onClick={() => onChoose(mode.value)}
            >
              <span className="create-type-card-icon"><Icon size={28} /></span>
              <span className="create-type-card-copy">
                <small>{mode.value === "post" ? "展示与交流" : "寻找设计服务"}</small>
                <strong>{mode.title}</strong>
                <span>{mode.description}</span>
              </span>
              <span className="create-type-card-action">
                <AccentIcon size={16} />
                {mode.action}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default function CreateHubPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const draftId = searchParams.get("draft");
  const requestedMode = searchParams.get("type");
  const activeMode = draftId
    ? "post"
    : createModes.some((mode) => mode.value === requestedMode)
      ? requestedMode
      : "";

  function chooseMode(mode) {
    navigate(`/create?type=${mode}`);
  }

  if (!activeMode) {
    return <CreateTypePicker onChoose={chooseMode} />;
  }

  return (
    <div className="create-hub-page">
      {!draftId ? (
        <CreateModeSwitcher activeMode={activeMode} onChange={chooseMode} />
      ) : null}
      {activeMode === "order" ? <NewOrderPage /> : <CreatePage />}
    </div>
  );
}
